const { sameRunStyleInTextBodies } = require('../utils');

exports.computeTextTransformFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'textTransform', undefined, { textSelection });
